import { render, staticRenderFns } from "./ClassificatorContent.vue?vue&type=template&id=043ec87a"
import script from "./ClassificatorContent.vue?vue&type=script&lang=js"
export * from "./ClassificatorContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports